import { instance, next } from "./base";

export const getWithdrawals = async (params) => {
  const { data } = await instance()
    .get("/api/v1/admin/withdrawals", { params })
    .catch((e) => next(e));
  return data?.data;
};

export const getWithdrawalSummary = async () => {
  const { data } = await instance()
    .get("/api/v1/admin/withdrawals/summary")
    .catch((e) => next(e));
  return data?.data;
};
